import type { LogoSize } from '@faceup/utils'
import FaceUpLogo from '../assets/logo-fu.svg'

const logoSizeStyle: Record<LogoSize, Record<'maxWidth' | 'maxHeight', number>> = {
  md: {
    maxWidth: 170,
    maxHeight: 44,
  },
  lg: {
    maxWidth: 170 * 1.5,
    maxHeight: 44 * 1.5,
  }, // header size 42 px
  xl: {
    maxWidth: 170 * 2,
    maxHeight: 44 * 2,
  }, // header size 54 px
}

type InstitutionLogoProps = {
  logoSize: LogoSize
  logoUrl: string | null
  name: string | null
}

const InstitutionLogo = ({ logoSize, logoUrl, name }: InstitutionLogoProps) => {
  return (
    <img
      src={logoUrl ?? FaceUpLogo}
      alt={name ?? 'FaceUp'}
      className='w-auto flex-shrink min-w-0'
      style={logoSizeStyle[logoSize]}
    />
  )
}

export default InstitutionLogo
